<script setup></script>

<template>
  <div class="pages-index">
    <div class="pages-index__borders">
      <div class="pages-index__borders-container container">
        <div class="pages-index__borders-body">
          <div class="pages-index__line pages-index__line--1"></div>

          <div class="pages-index__line pages-index__line--2"></div>
        </div>
      </div>
    </div>

    <SectionsIntro class="pages-index__sections-intro" />

    <SectionsAchievements class="pages-index__sections-achievements" />

    <SectionsSolutions class="pages-index__sections-solutions" />

    <SectionsProducts class="pages-index__sections-products" />

    <SectionsTechnologies class="pages-index__sections-technologies" />

    <SectionsApproach class="pages-index__sections-approach" />

    <SectionsContactUs class="pages-index__contact-us" />
  </div>
</template>

<style scoped lang="scss">
.pages-index {
  position: relative;
  background: $bg-main;

  &__borders {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  &__borders-container {
    height: 100%;

    @include media-breakpoint-down(md) {
      max-width: em(768);
    }
  }

  &__borders-body {
    position: relative;
    height: 100%;
  }

  &__line {
    position: absolute;
    top: 0;
    z-index: 1;
    width: 1px;
    height: 100%;
    background-image: url('#{$icons-path}/dash-vert.svg');
    background-repeat: repeat-y;
    background-size: em(3);

    @include media-breakpoint-down(md) {
      background-size: em(2);
    }

    &--1 {
      left: 0;
    }

    &--2 {
      right: 0;
    }
  }

  &__sections-intro {
  }

  &__sections-achievements {
    position: relative;
    z-index: 1;
  }

  &__sections-solutions {
    overflow: hidden;
  }

  &__sections-products {
    position: relative;
    z-index: 1;
  }

  &__sections_technologies {
  }

  &__sections-approach {
    position: relative;
    z-index: 1;
  }

  &__contact-us {
  }
}
</style>
